import { render, staticRenderFns } from "./recordListContent.vue?vue&type=template&id=1146f217&scoped=true&"
import script from "./recordListContent.vue?vue&type=script&lang=ts&"
export * from "./recordListContent.vue?vue&type=script&lang=ts&"
import style0 from "./recordListContent.vue?vue&type=style&index=0&id=1146f217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146f217",
  null
  
)

export default component.exports